
// import type { ComponentProps } from "react";

// export const UserProfile = (props: ComponentProps<"svg">) => {
//     return (
//         // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" enableBackground="new 0 0 32 32" xmlSpace="preserve" {...props}>
//         //     <path d="M16 31C7.729 31 1 24.271 1 16S7.729 1 16 1s15 6.729 15 15-6.729 15-15 15zm0-28C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13S23.168 3 16 3z" />
//         //     <circle cx="16" cy="11.368" r="3.368" />
//         //     <path d="M20.673 24h-9.346c-.83 0-1.502-.672-1.502-1.502v-.987a5.404 5.404 0 0 1 5.403-5.403h1.544a5.404 5.404 0 0 1 5.403 5.403v.987c0 .83-.672 1.502-1.502 1.502z" />
//         // </svg>
//         // <svg
//         //     preserveAspectRatio="xMidYMid meet"
//         //     width="80px" height="80px" viewBox="0 0 512 512"
//         //     fill="none"
//         //     xmlns="http://www.w3.org/2000/svg"
//         //     {...props}>
//             {/* <path d="M691.573 338.89c-1.282 109.275-89.055 197.047-198.33 198.331-109.292 1.282-197.065-90.984-198.325-198.331-0.809-68.918-107.758-68.998-106.948 0 1.968 167.591 137.681 303.31 305.272 305.278C660.85 646.136 796.587 503.52 798.521 338.89c0.811-68.998-106.136-68.918-106.948 0z"
//                 fill="#4A5699" />
//             <path d="M294.918 325.158c1.283-109.272 89.051-197.047 198.325-198.33 109.292-1.283 197.068 90.983 198.33 198.33 0.812 68.919 107.759 68.998 106.948 0C796.555 157.567 660.839 21.842 493.243 19.88c-167.604-1.963-303.341 140.65-305.272 305.278-0.811 68.998 106.139 68.919 106.947 0z"
//                 fill="#C45FA0" />
//             <path d="M222.324 959.994c0.65-74.688 29.145-144.534 80.868-197.979 53.219-54.995 126.117-84.134 201.904-84.794 74.199-0.646 145.202 29.791 197.979 80.867 54.995 53.219 84.13 126.119 84.79 201.905 0.603 68.932 107.549 68.99 106.947 0-1.857-213.527-176.184-387.865-389.716-389.721-213.551-1.854-387.885 178.986-389.721 389.721-0.601 68.991 106.349 68.933 106.949 0.001z"
//                 fill="#E5594F" />
//         </svg> */}

//         //     <path d="M691.573 338.89c-1.282 109.275-89.055 197.047-198.33 198.331-109.292 1.282-197.065-90.984-198.325-198.331-0.809-68.918-107.758-68.998-106.948 0 1.968 167.591 137.681 303.31 305.272 305.278C660.85 646.136 796.587 503.52 798.521 338.89c0.811-68.998-106.136-68.918-106.948 0z" fill="#4A5699" /><path d="M294.918 325.158c1.283-109.272 89.051-197.047 198.325-198.33 109.292-1.283 197.068 90.983 198.33 198.33 0.812 68.919 107.759 68.998 106.948 0C796.555 157.567 660.839 21.842 493.243 19.88c-167.604-1.963-303.341 140.65-305.272 305.278-0.811 68.998 106.139 68.919 106.947 0z" fill="#C45FA0" />
//         //     <path d="M222.324 959.994c0.65-74.688 29.145-144.534 80.868-197.979 53.219-54.995 126.117-84.134 201.904-84.794 74.199-0.646 145.202 29.791 197.979 80.867 54.995 53.219 84.13 126.119 84.79 201.905 0.603 68.932 107.549 68.99 106.947 0-1.857-213.527-176.184-387.865-389.716-389.721-213.551-1.854-387.885 178.986-389.721 389.721-0.601 68.991 106.349 68.933 106.949 0.001z" fill="#E5594F" />

//         // </svg>
//     );
// };


import { type ComponentProps } from "react";

export const UserProfile = (props: ComponentProps<"svg">) => (
    <svg
        width="100%"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Top Arc (Pink) */}
        <path
            d="
        M 50 60
        A 50 50 0 1 1 150 60
        A 50 50 0 1 1 50 60
      "
            stroke={"#C06BA8"}
            strokeWidth="20"
            fill="none"
            strokeLinecap="round"
        />

        {/* Middle Arc (Blue) */}
        <path
            d="
        M 50 60
        A 50 50 0 0 0 150 60
      "
            stroke={"#4A4A9F"}
            strokeWidth="20"
            fill="none"
            strokeLinecap="round"
        />

        {/* Bottom Arc (Orange) */}
        <path
            d="
        M 40 148
        A 60 60 0 0 1 160 148
      "
            stroke={"#D46555"}
            strokeWidth="18"
            fill="none"
            strokeLinecap="round"
        />
    </svg>
);
